import { render, staticRenderFns } from "./gc-popup-general-data-grid.vue?vue&type=template&id=45ca5a08"
import script from "./gc-popup-general-data-grid.vue?vue&type=script&lang=js"
export * from "./gc-popup-general-data-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports